/**
 * Redux action type constants for the settings module.
 *
 * @module redux/settings/settingsType
 * @author Snowfly
 * @version 1.0.0
 */
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_STATUS = 'FETCH_STATUS';
export const FETCH_SUB_STATUS = 'FETCH_SUB_STATUS';
export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_GROUPS = 'FETCH_GROUPS';
export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
